<script setup>
const gsapTimeline = useGsapTimeline()
const textElement = ref(null)
const textElementChildren = ref(null)

const props = defineProps({
  text: String,
})

const emit = defineEmits(['timeline'])

onMounted(() => {
  const timeline = gsapTimeline({ name: 'CharacterEnlarge' })
    .startInvisible(textElement)
    .from(shuffle(textElementChildren.value.slice(1)).slice(props.text.length / 2), { transformOrigin: 'center 80%', scale: 0.5, duration: 0.05, stagger: { amount: 0.19 }, ease: 'power4.out' })
    .from(textElement, { letterSpacing: '-8px', duration: 0.24, ease: 'power1.out' }, '<')

  emit('timeline', timeline)
})
</script>

<template>
  <SplitCharacters ref="textElement" :text="text" @container="textElement = $event" @children="textElementChildren = $event" />
</template>
